export default "__VITE_ASSET__VksXFc1h__"